import './index.scss';

import { Rive } from '@rive-app/canvas-lite';

class InlineCanvas {
    constructor(root) {
        this.canvas = root;
        this.initCanvas();
    }

    initCanvas() {
        this.isCanvasPlaying = false;

        this.rive = new Rive({
            canvas: this.canvas,
            src: this.canvas.dataset.src,
            onLoad: () => {
                this.rive.resizeDrawingSurfaceToCanvas();
            },
        });

        window.addEventListener('scroll', this.scroll.bind(this));
        this.scroll();
    }

    scroll() {
        let rect = this.canvas.getBoundingClientRect();
        let top = rect.top + rect.height / 2;
        let bottom = rect.top + rect.height / 2 - window.innerHeight;

        if (bottom <= 0 && 0 < top) {
            if (!this.isCanvasPlaying) {
                this.rive.play();
                this.isCanvasPlaying = true;
            }
        }
    }
}

class InlineVideo {
    constructor(root) {
        this.video = root;
        this.initVideo();
    }

    initVideo() {
        this.isVideoPlaying = false;

        window.addEventListener('scroll', this.scroll.bind(this));
        this.scroll();
    }

    scroll() {
        if (this.video.readyState === 0) {
            setTimeout(() => { this.scroll(); }, 100);
            return;
        }

        let rect = this.video.getBoundingClientRect();
        let top = rect.top + rect.height / 2;
        let bottom = rect.top + rect.height / 2 - window.innerHeight;

        if (bottom <= 0 && 0 < top) {
            if (!this.isVideoPlaying) {
                this.video.play();
                this.isVideoPlaying = true;
            }
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('.inlinevideo canvas').forEach((node) => {
        new InlineCanvas(node);
    });

    document.querySelectorAll('.inlinevideo video').forEach((node) => {
        new InlineVideo(node);
    });
});
